var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.239216 0 0 0 0 0.862745 0 0 0 0 0.517647 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007BFF",
    d: "M0 0H64V64H0z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M30.51 18.92H9.494c-.58 0-1.051.47-1.051 1.05v16.815c0 2.539 1.807 4.66 4.203 5.15v5.36c0 1.737 1.415 3.152 3.153 3.152s3.153-1.415 3.153-3.153V42.04h2.102v5.254c0 1.738 1.414 3.153 3.152 3.153 1.738 0 3.153-1.415 3.153-3.153v-5.36c2.396-.487 4.204-2.61 4.204-5.149V19.971c0-.583-.471-1.051-1.051-1.051zM25.502 5.6l1.772-4.134c.229-.534-.019-1.15-.553-1.379-.528-.23-1.152.017-1.379.553L23.57 4.777c-1.124-.366-2.322-.57-3.566-.57-1.245 0-2.443.204-3.567.57L14.66.64c-.227-.536-.851-.786-1.379-.553-.534.23-.78.847-.55 1.38L14.503 5.6c-3.608 1.96-6.061 5.783-6.061 10.167 0 .58.47 1.05 1.05 1.05h21.019c.58 0 1.05-.47 1.05-1.05 0-4.384-2.452-8.208-6.059-10.167zm-9.704 7.014c-.58 0-1.05-.47-1.05-1.05 0-.58.47-1.052 1.05-1.052.58 0 1.051.471 1.051 1.051s-.47 1.051-1.051 1.051zm8.407 0c-.58 0-1.05-.47-1.05-1.05 0-.58.47-1.052 1.05-1.052.58 0 1.051.471 1.051 1.051s-.47 1.051-1.05 1.051zM36.816 18.92c-1.738 0-3.153 1.414-3.153 3.152v10.51c0 1.738 1.415 3.152 3.153 3.152s3.153-1.414 3.153-3.153V22.072c0-1.738-1.415-3.152-3.153-3.152zM3.187 18.92c-1.738 0-3.153 1.414-3.153 3.152v10.51c0 1.738 1.415 3.152 3.153 3.152S6.34 34.32 6.34 32.581V22.072c0-1.738-1.415-3.152-3.153-3.152z",
    transform: "translate(12 7)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidSquare);
export default __webpack_public_path__ + "static/media/androidSquare.8ee65fa5420c1257c92ecdb7aff9bce9.svg";
export { ForwardRef as ReactComponent };